module.exports = __webpack_public_path__ + "img/icon-arrow-right-light-no-outline.228d213e.svg";